import { TooltipText } from 'components/shared';
import { getTheme, mergeStyles, Stack, Text } from '@fluentui/react';
import React from 'react';
import {
  empty,
  jsonImageCaptionWrapperClass,
  jsonImageCaptionOverlayClass,
  jsonImageCaptionOverlayStyle,
  jsonImageCaptionStyle,
  JsonImgNodeProps
} from '../JsonFrame';
import { JsonContentValidationMessage } from './JsonContentValidationMessage';
import { generateImageFilters } from '../../../util/smallFuncs';
import { DEFAULT_MAX_MEDIA_HEIGHT } from '../../../admin/MediaHeightField';

export const ImageBytesType: React.FunctionComponent<JsonImgNodeProps> = (props): JSX.Element => {
  const { palette, fonts } = getTheme();
  const imgWrapperAdditionalClass = 'position-relative';
  const imgWrapperClass = mergeStyles(
    {
      backgroundColor: palette.neutralDark
    },
    imgWrapperAdditionalClass
  );
  const imgBytesValidationMessageClass = mergeStyles(
    {
      minHeight: props.isZoomInActive ? 500 : ''
    },
    'ml-3'
  );
  const imageFilter = generateImageFilters(props.subjectImagePreferences);
  const baseStyle = props.isGridView
    ? { width: '100%', height: (props.uxPreferences?.maxCardHeight || 300) - (props.extraHeight || 0) }
    : { height: `${props.subjectImagePreferences?.maxHeight || DEFAULT_MAX_MEDIA_HEIGHT}px` };

  const zoominStyles = {
    height: `${props.subjectImagePreferences?.maxHeight || DEFAULT_MAX_MEDIA_HEIGHT}px`,
    maxWidth: '100%'
  };

  return (
    <Stack className={imgWrapperClass} style={props.isZoomInActive ? {} : baseStyle}>
      {!empty(props.caption) && (
        <>
          <Stack className={jsonImageCaptionOverlayClass} style={jsonImageCaptionOverlayStyle(palette)}></Stack>
          <Stack className={jsonImageCaptionWrapperClass(props.isZoomInActive)}>
            <Text style={jsonImageCaptionStyle(palette, fonts, 'white', 'large')}>{props.caption}</Text>
          </Stack>
        </>
      )}
      <Stack.Item
        className="overflow-hidden"
        style={props.isZoomInActive ? {} : { maxHeight: '100%', maxWidth: '100%' }}
      >
        {!empty(props.value) ? (
          <img
            alt={props.value}
            src={'data:image/png;base64,' + props.value}
            className="d-block mx-auto"
            style={props.isZoomInActive ? zoominStyles : { ...baseStyle, ...imageFilter }}
          />
        ) : (
          <div className="mt-4 pt-3">
            <JsonContentValidationMessage
              message={TooltipText.imageBytesTypeValidationMessage}
              validationMessageWrapperClass={imgBytesValidationMessageClass}
            />
          </div>
        )}
      </Stack.Item>
    </Stack>
  );
};
